import * as types from '../../mutation-types';


export function open({ commit }) {
    commit(types.SET_LATERAL_MENU, { isOpen: true });
}

export function close({ commit }) {
    commit(types.SET_LATERAL_MENU, { isOpen: false });
}

export function toggle({ commit, state }) {
    commit(types.SET_LATERAL_MENU, { isOpen: !state.isOpen });
}
